module.exports = __webpack_public_path__ + "static/media/import_01.11570252.svg";